import { useGetLoginInfo } from '@multiversx/sdk-dapp/hooks/account'
import { useWebWalletLogin } from '@multiversx/sdk-dapp/hooks/login'
import { logout } from '@multiversx/sdk-dapp/utils'

import MultiversX from 'src/assets/logos/MultiversX.svg'

const ConnectMvxWallet = () => {
  const { isLoggedIn } = useGetLoginInfo()

  const [initiateWebWalletLogin] = useWebWalletLogin({
    callbackRoute: window.location.pathname + window.location.search,
    token: 'token',
    nativeAuth: false,
  })

  return (
    <div className="flex">
      {isLoggedIn ? (
        <button
          onClick={() => logout(window.location.pathname + window.location.search)}
          className="grid gap-3 rounded-lg border border-main-blue bg-white bg-opacity-5 p-4 text-white outline-0">
          <img src={MultiversX} alt="MultiversX" className="mx-auto h-6 w-24" />
          <span className="text-sm font-light">Disconnect MultiversX wallet</span>
        </button>
      ) : (
        <button
          onClick={() => initiateWebWalletLogin()}
          className="grid gap-3 rounded-lg border border-white border-opacity-20 bg-white bg-opacity-5 p-4 text-white outline-0">
          <img src={MultiversX} alt="MultiversX" className="mx-auto h-6 w-24" />
          <span className="text-sm font-light">Connect MultiversX wallet</span>
        </button>
      )}
    </div>
  )
}

export default ConnectMvxWallet
